<template>
<div>
    <my-header></my-header>
    <div class="pd20">
        <loading :text="'Please wait'|translate" v-if="loading"></loading>
        <p v-if="!land_item">{{'No result'|translate}}</p>
        <div class="land-detail" v-if="land_item">
            <div class="row">
                <div class="col-md-9 mb20">
                    <ol class="breadcrumb">
                        <li>
                            <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'LandMarket', params: {  }}">{{'Find land'|translate}}</router-link>
                        </li>
                        <li class="active">{{land_item.title}}</li>
                    </ol>
                    <h3>{{land_item.title}}</h3>
                    <p class="meta" v-if="land_item.price">
                        <strong>{{'Price'|translate}}:</strong> <span class="price">{{toCommas(land_item.price)}}đ&nbsp;&nbsp;</span>
                    </p>
                    <p>
                        <strong>{{'Area'|translate}}:</strong> {{toCommas(land_item.area)}} m2 - <strong>{{'Residental'|translate}}:</strong> {{toCommas(land_item.residental_area)}} m2
                    </p>
                    <hr />
                    <div class="description" v-html="land_item.description"></div>

                    <p class="mt20">
                        <i class="fas fa-map-marker-alt"></i>
                        <strong>Địa chỉ BDS</strong>
                    </p>
                    <p>{{land_item.commune_name}}, {{land_item.district_name}}, {{land_item.province_name}}</p>
                    <div v-if="photos !== null">
                        <p class="mt20">
                            <i class="fas fa-images"></i>
                            <strong>{{'Attached images'|translate}}</strong>
                        </p>
                        <div class="gallery">
                            <p v-if="photos && photos.length === 0">{{'There is no attach photo'|translate}}</p>
                            <a class="wrap" v-for="(photo, photoIndex) in photos" :key="photoIndex" @click="index = photoIndex">
                                <img class="thumb" :src="photo.url_thumb" />
                            </a>
                        </div>
                    </div>
                    <gallery v-if="photos" :images="images" :index="index" @close="index = null"></gallery>
                </div>
                <div class="col-md-3">
                    <div class="media">
                        <div class="media-left">
                            <i class="fas fa-user-circle fa-2x"></i>
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">
                                <router-link :to="{ name: 'Profile', params: { profileId: land_item.user_unique_code }}">{{land_item.owner_name}}</router-link>
                            </h4>
                        </div>
                    </div>
                    <hr />
                    <a class="btn btn-primary" :href="'tel:'+ land_item.owner_phone">
                        <i class="fas fa-phone"></i>
                        {{land_item.owner_phone}}
                    </a>
                    <hr />
                    <div class="resources mt20">
                        <p>
                            <strong>{{'Resources'|translate}}</strong>
                        </p>
                        <p>
                            <i class="fas fa-cookie"></i>
                            {{'Area'|translate}}: {{toCommas(land_item.area)}}m2
                        </p>

                        <p>
                            <i class="fas fa-bolt"></i>
                            {{'Electric'|translate}}: {{yesNoLabel(land_item.resource_electric)}}
                        </p>
                        <p>
                            <i class="fas fa-tint"></i>
                            {{'Water'|translate}}: {{yesNoLabel(land_item.resource_water)}}
                        </p>

                        <p>
                            <i class="fas fa-road"></i>
                            {{'Transport'|translate}}: {{showStreet(land_item.street_type)}}
                        </p>
                        <p>
                            <i class="fas fa-certificate"></i>
                            {{'Paper'|translate}}: {{showCertificate(land_item.certificate_type)}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import gallery from "vue-gallery";
export default {
    name: "LandDetail",
    components: {
        MyHeader,
        Loading,
        gallery
    },
    data() {
        return {
            land_item: null,
            loading: true,
            index: null
        };
    },
    computed: {
        images() {
            if (this.photos) {
                return this.photos.map(item => {
                    return item.url_medium;
                });
            } else {
                return [];
            }
        },
        photos() {
            return this.land_item ? this.land_item.list_images : [];
        }
    },
    methods: {
        toCommas(value) {
            return Utils.toCommas(value);
        },
        getData() {
            Utils.request(this, true, "landmarket")
                .get(`/searchLand/${this.id}`)
                .then(response => {
                    let data = response.data;
                    if (data.status === "ok") {
                        this.land_item = response.data.data;
                        this.loading = false;
                    }
                })
                .catch(error => {
                    this.updating = false;
                    Utils.showErrorMessage(this, error.response);
                });
        },
        yesNoLabel(value) {
            return value === "1" ? this.$t("Yes") : this.$t("No");
        },
        showStreet(value) {
            return Utils.getStreetType(value)
        },
        showCertificate(value) {
            return Utils.getCertificateType(value)
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getData();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Land/LandDetail.vue